import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { makeStyles } from '@hawkins/styles';
var cssBaselineStyles = function (theme) {
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables;
    return {
        '@global': {
            html: {
                WebkitFontSmoothing: 'antialiased',
                MozOsxFontSmoothing: 'grayscale',
                fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
            },
            'strong, b': {
                fontWeight: hawkinsVariables.fontWeights.fontWeight1,
            },
            body: {
                margin: 0,
                fontFamily: hawkinsVariables.fontFamily.fontFamilySans,
                fontSize: hawkins.body.fontSize0,
                color: hawkins.textColor.textColorRegular,
                fontWeight: hawkins.body.fontWeightRegular,
                lineHeight: hawkins.body.lineHeightRegular,
                backgroundColor: hawkins.ui.backgroundColor0,
                letterSpacing: 0,
            },
        },
    };
};
var useStyleReset = makeStyles(cssBaselineStyles, { name: 'Hawkins-CSSBaseline' });
/**
 * Provides a nice base of CSS for your application.
 */
export var CSSBaseline = function () {
    useStyleReset();
    return _jsx(React.Fragment, {});
};
CSSBaseline.displayName = 'CSSBaseline';
